<template>
  <table-widget :items="files" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
    <template slot="buttons">
      <b-button v-if="isContractManager" :to="{ name: 'contractFile', params: { contractId: contractId } }" class="new-content-button"><font-awesome-icon icon="plus" /> Add New File</b-button>
    </template> 
    <template slot="content">
      <b-table striped
          hover
          :items="files"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-compare="customSort"
          :filter="filter"
          @filtered="onFiltered"
          responsive
          small>
        <template slot="fileName" slot-scope="data">
          <a :href="getFileHref(data.item)">{{ data.item.fileName }}</a>
        </template>
        <template slot="type" slot-scope="data">
          {{ data.item.contractFileType.contractFileTypeLabel }}
        </template>
        <template slot="createdDate" slot-scope="data">
          {{ data.item.createdDate | formatDate }}
        </template>
        <template slot="startDate" slot-scope="data">
          {{ data.item.startDate | formatDate }}
        </template>
        <template slot="endDate" slot-scope="data">
          {{ data.item.endDate | formatDate }}
        </template>
      </b-table>
    </template>
  </table-widget>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../../misc/role-checks";
import TableWidget from "../table-widget";

export default {
  mixins: [roleChecks],
  data() {
    return {
      fields: [
        { key: "fileName", sortable: true },
        { key: "type", sortable: true },
        { key: "createdDate", sortable: true },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true },
        { key: "createdBy", sortable: true }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null
    };
  },

  components: {
    "table-widget": TableWidget
  },

  props: {
    files: {
      type: Array,
      required: true
    },
    contractId: {
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    customSort(a, b, key) {
      if (key === "type") {
        var categoryNameA = a.contractFileType.contractFileTypeLabel;
        var categoryNameB = b.contractFileType.contractFileTypeLabel;
        return categoryNameA.localeCompare(categoryNameB);
      } else {
        return null;
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getFileHref: function(file) {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/downloads/contractfile?id=" +
        file.contractFileId
      );
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
